module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-x-3b59cfdd.svg";